const VAN_BOOKING_ORDER_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
}

export { VAN_BOOKING_ORDER_STATUS }
